var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.37496 15.5833C6.76616 15.5833 7.08329 15.2662 7.08329 14.875C7.08329 14.4838 6.76616 14.1667 6.37496 14.1667C5.98376 14.1667 5.66663 14.4838 5.66663 14.875C5.66663 15.2662 5.98376 15.5833 6.37496 15.5833Z",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 15.5833C14.5579 15.5833 14.875 15.2662 14.875 14.875C14.875 14.4838 14.5579 14.1667 14.1667 14.1667C13.7755 14.1667 13.4584 14.4838 13.4584 14.875C13.4584 15.2662 13.7755 15.5833 14.1667 15.5833Z",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.708374 0.708344H3.54171L5.44004 10.1929C5.50481 10.519 5.68223 10.812 5.94122 11.0205C6.20021 11.229 6.52428 11.3397 6.85671 11.3333H13.7417C14.0741 11.3397 14.3982 11.229 14.6572 11.0205C14.9162 10.812 15.0936 10.519 15.1584 10.1929L16.2917 4.25001H4.25004",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkCartIcon);
export default __webpack_public_path__ + "static/media/darkCartIcon.9044f1d3aedc1125a82510a8dd8894e1.svg";
export { ForwardRef as ReactComponent };